import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {deleteActiveMotorSort, deleteActivemotorSort, setActiveMotorSort, setActivemotorSort} from "../../helpers/product";
import { isMobileOnly} from "react-device-detect";
import qs from "query-string";
import {useTranslation} from "react-i18next";

const ShopIsMotorPref = ({ location, currentQuery, setCurrentQuery, motors, getSortParams, isHome }) => {
  const [isSmallScreen, setSmallScreen] = useState(false);
    const { t } = useTranslation()

  const query = qs.parse(location.search, {
      ignoreQueryPrefix: true
  });
  const filterButtons = document.querySelectorAll(
      ".sidebar-widget-tag-is-motor-pref button"
  );

    filterButtons.forEach(item => {
        item.classList.remove("active");
    });

    if (query && query.isMotor) {
        let motors = query.isMotor.split('_');
        motors.map(size => {
            var element = document.getElementById("isMotor"+size);
            if (element){
                element.classList.add("active")
            }
        })
    }

    useEffect(() => {
        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        }
    }, [])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(false)
        }
    })

    function constructAddQueryPath(query, size) {
        if (query && query.motor) {
            return query.motor + "_" + size
        }
        return size
    }

  return (
    <div className="sidebar-widget mt-10">
        {
            isMobileOnly || isSmallScreen ?
                <div>
                    <h4 className="pro-sidebar-title">{isHome ? "Connaissez-vous sa préférence motrice ?" : "Avec préférence motrice :"} &nbsp;
                    </h4>
                    <div className="sidebar-widget-tag-is-motor-pref mt-10" style={{display: 'block'}}>
                        {motors ? (
                            <ul>
                                {motors.map((isMotor, key) => {
                                    return (
                                        <li key={"isMotor"+key}>
                                            <button
                                                className="toto"
                                                id={"isMotor"+isMotor}
                                                onClick={e => {
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("isMotor", "");
                                                        setCurrentQuery({ ...currentQuery, isMotor: ""});
                                                        deleteActiveMotorSort(e);
                                                    } else {
                                                        getSortParams("isMotor", isMotor);
                                                        setCurrentQuery({ ...currentQuery, isMotor: isMotor, motor: "", types: "", pains: "", analysis: "", shoeType: "", shoeDistance :"", isPain : ""});
                                                        setActiveMotorSort(e);
                                                    }
                                                }}
                                            >
                                                {t(isMotor.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
                :
                <div>
                    <h4 className="pro-sidebar-title">{isHome ? "Connaissez-vous sa préférence motrice ?" : "Avec préférence motrice :"} &nbsp;</h4>
                    <div className="sidebar-widget-tag-is-motor-pref mt-10">
                        {motors ? (
                            <ul>
                                {motors.map((isMotor, key) => {
                                    return (
                                        <li key={"isMotor"+key}>
                                            <button
                                                className="toto"
                                                id={"isMotor"+isMotor}
                                                onClick={e => {
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("isMotor", "");
                                                        setCurrentQuery({ ...currentQuery, isMotor: ""});
                                                        deleteActiveMotorSort(e);
                                                    } else {
                                                        getSortParams("isMotor", isMotor);
                                                        setCurrentQuery({ ...currentQuery, isMotor: isMotor, motor: "", types: "", pains: "", analysis: "", shoeType: "", shoeDistance :"", isPain : ""});
                                                        setActiveMotorSort(e);
                                                    }
                                                }}
                                            >
                                                {t(isMotor.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
        }
    </div>
  );
};

export function ConstructRemovemotorQueryPath(query, sizeToRemove) {
    if (query && query.motor) {
        let motors = query.motor.split('_');
        motors = motors.filter(size => {
            return size !== sizeToRemove;
        })
        if (motors.length > 0) {
            let newSizeQuery = ""
            motors.map((size, index) => {
                if (index == 0){
                    newSizeQuery += size
                } else {
                    newSizeQuery +=  "_" + size
                }
            })
            return newSizeQuery
        } else {
            return null
        }

    }
    return null
}

ShopIsMotorPref.propTypes = {
  getSortParams: PropTypes.func,
  tags: PropTypes.array,
  currentQuery: PropTypes.object,
  setCurrentQuery: PropTypes.func,
    location: PropTypes.string
};

export default ShopIsMotorPref;
